<article
  class="event-card"
  [class.event-card--with-image]="!!thumbUrl()"
  [attr.data-type]="event().type"
>
  <!-- <img> normal y no NgOptimizedImage (dimensiones del cartel desconocidas).
       Decorativa (alt vacío: el nombre ya está en el botón); el ::after del
       botón la cubre, así que pulsarla abre el detalle. -->
  @if (thumbUrl(); as src) {
    <img
      class="event-card__thumb"
      [src]="src"
      alt=""
      width="64"
      height="64"
      loading="lazy"
      decoding="async"
      (error)="onThumbError(src)"
    />
  }
  <div class="event-card__date" aria-hidden="true">
    <span class="event-card__day">{{ dayNumber() }}</span>
    <span class="event-card__month">{{ monthLabel() }}</span>
  </div>

  <div class="event-card__body">
    <span class="event-card__tags">
      <span class="event-card__type">{{ typeLabel() }}</span>
      @if (showGame()) {
        <span class="event-card__game" [class.event-card__game--store]="!event().game">
          {{ gameLabel() }}
        </span>
      }
    </span>

    <h3 class="event-card__name">
      <!-- Único tab stop de la tarjeta: el botón se estira sobre ella entera
           (::after), así que se abre el detalle pulsando en cualquier punto. -->
      <button
        type="button"
        class="event-card__open"
        aria-haspopup="dialog"
        [attr.aria-label]="openLabel()"
        (click)="openDetails()"
      >
        {{ event().name }}
      </button>
    </h3>

    <p class="event-card__meta">
      {{ dateLabel() }}
      @if (timeLabel()) {
        <span class="event-card__time">{{ copy.eventTimeFrom }} {{ timeLabel() }}</span>
      }
      @if (event().format) {
        <span class="event-card__format">· {{ event().format }}</span>
      }
    </p>

    <p class="event-card__location">
      <app-icon [icon]="mapPinIcon" [size]="14" />
      {{ event().location }}
    </p>
  </div>

  @if (priceLabel()) {
    <span class="event-card__price">{{ priceLabel() }}</span>
  }
</article>
